import { render, staticRenderFns } from "./CloudPage.vue?vue&type=template&id=53b8dbfa&scoped=true"
import script from "./CloudPage.vue?vue&type=script&lang=js"
export * from "./CloudPage.vue?vue&type=script&lang=js"
import style0 from "./CloudPage.vue?vue&type=style&index=0&id=53b8dbfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b8dbfa",
  null
  
)

export default component.exports